

























import {
  defineComponent,
} from '@vue/composition-api';
import { useFormat } from '@ideavivat/vivat-2';

const PanelWithExpenseSummary = defineComponent({
  props: {
    budget: {},
    usedBudget: {},
    isViewExpense: {},
  },
  setup(props) {
    const toDateTime = (date: string): string => useFormat.date(date).displayFullThaiDateTime();
    const toCurrency = (amount: string | number): string => useFormat.number(amount).currency();
    return {
      toDateTime,
      toCurrency,
    };
  },
});

export default PanelWithExpenseSummary;
